import React, { useState } from "react";
import NotificacionesMasivas from "./components/NotificacionesMasivas";
import GestionPerfiles from "./components/GestionPerfiles";
import GestionMenus from "./components/GestionMenus";
import GestionSedes from "./components/GestionSedes";
import SincronizadorSysplus from "./components/SincronizadorSysplus";

export default function PanelHerramientasAdmin({ onBack }) {
  const [herramientaActiva, setHerramientaActiva] = useState(null);
  const [animating, setAnimating] = useState(false);

  const handleOpenTool = (id) => {
    setAnimating(true);
    setTimeout(() => {
      setHerramientaActiva(id);
      setAnimating(false);
    }, 200);
  };

  const handleCloseTool = () => {
    setAnimating(true);
    setTimeout(() => {
      setHerramientaActiva(null);
      setAnimating(false);
    }, 200);
  };

  const herramientas = [
    {
      id: "notificaciones",
      title: "Notificaciones Masivas",
      description: "Envía alertas y avisos globales al instante a los colaboradores.",
      icon: "📢",
      color: "text-rose-600",
      bgIcon: "bg-rose-50/90 border-rose-200/60",
      badgeBg: "bg-rose-100/80 text-rose-700"
    },
    {
      id: "perfiles",
      title: "Gestión de Perfiles y ABAC",
      description: "Configura roles, credenciales, sedes y permisos por usuario.",
      icon: "🛡️",
      color: "text-indigo-600",
      bgIcon: "bg-indigo-50/90 border-indigo-200/60",
      badgeBg: "bg-indigo-100/80 text-indigo-700"
    },
    {
      id: "menus",
      title: "Gestor de Módulos (Menús)",
      description: "Habilita, oculta o crea sub-formularios en la plataforma.",
      icon: "📑",
      color: "text-emerald-600",
      bgIcon: "bg-emerald-50/90 border-emerald-200/60",
      badgeBg: "bg-emerald-100/80 text-emerald-700"
    },
    {
      id: "sedes",
      title: "Administración de Sedes",
      description: "Gestiona centros de trabajo, bodegas y flota de vehículos.",
      icon: "🏢",
      color: "text-cyan-600",
      bgIcon: "bg-cyan-50/90 border-cyan-200/60",
      badgeBg: "bg-cyan-100/80 text-cyan-700"
    },
    {
      id: "sysplus",
      title: "Sincronizador Sysplus",
      description: "Ejecuta y supervisa la sincronización maestra de datos.",
      icon: "🔄",
      color: "text-blue-600",
      bgIcon: "bg-blue-50/90 border-blue-200/60",
      badgeBg: "bg-blue-100/80 text-blue-700"
    }
  ];

  return (
    <div className="w-full py-4 px-3 sm:px-6 flex flex-col items-center justify-start relative z-10">
      
      {/* CONTENEDOR PRINCIPAL GLASSMORPHISM (Igual al Dashboard principal pero compacto) */}
      <div className="w-full max-w-6xl bg-white/45 backdrop-blur-[40px] border border-white/80 rounded-[28px] p-5 sm:p-7 shadow-[0_20px_50px_rgba(0,0,0,0.12)] transition-all">
        
        {/* CABECERA COMPACTA CON BOTÓN CORTO */}
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 pb-5 mb-6 border-b border-slate-800/10">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-8 h-8 rounded-xl bg-blue-600 text-white flex items-center justify-center text-sm shadow-sm">
                ⚙️
              </span>
              <h1 className="text-xl sm:text-2xl font-black text-slate-900 tracking-tight">
                Panel de Control <span className="text-blue-600">Super Admin</span>
              </h1>
            </div>
            <p className="text-xs text-slate-600 font-semibold mt-1">
              Selecciona la herramienta administrativa que deseas gestionar.
            </p>
          </div>

          <div className="flex items-center gap-2 self-start sm:self-auto">
            {herramientaActiva && (
              <button
                type="button"
                onClick={handleCloseTool}
                className="w-auto flex-none px-4 py-2 bg-white/80 hover:bg-white text-slate-700 hover:text-blue-600 rounded-xl font-black text-[11px] uppercase tracking-wider border border-white shadow-sm transition-all cursor-pointer flex items-center gap-1.5"
              >
                <span></span> Volver a Herramientas
              </button>
            )}

            <button
              type="button"
              onClick={onBack}
              className="w-auto flex-none px-4 py-2 bg-slate-900 hover:bg-slate-800 text-white font-black text-[11px] uppercase tracking-wider rounded-xl shadow-sm transition-all cursor-pointer flex items-center gap-1.5"
            >
              <span>🏠</span> Menú Principal
            </button>
          </div>
        </div>

        {/* VISTA 1: CUADRÍCULA DE TARJETAS COMPACTAS */}
        {!herramientaActiva && (
          <div className={`transition-all duration-200 ${animating ? "opacity-0 scale-98" : "opacity-100 scale-100"}`}>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
              {herramientas.map((item) => (
                <div
                  key={item.id}
                  onClick={() => handleOpenTool(item.id)}
                  className="glass-reflection card-hover p-5 rounded-2xl border border-white/90 shadow-sm cursor-pointer flex flex-col justify-between min-h-[175px] group"
                >
                  <div>
                    <div className="flex items-center justify-between mb-3">
                      <div className={`w-11 h-11 rounded-xl ${item.bgIcon} ${item.color} border flex items-center justify-center text-xl shadow-inner icon-bounce`}>
                        {item.icon}
                      </div>
                      <span className={`text-[9px] font-black px-2.5 py-1 rounded-md uppercase tracking-wider ${item.badgeBg}`}>
                        Activo
                      </span>
                    </div>

                    <h3 className="font-black text-slate-800 text-sm sm:text-base tracking-tight mb-1 group-hover:text-blue-700 transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-[11px] text-slate-600 font-medium leading-snug">
                      {item.description}
                    </p>
                  </div>

                  <div className="flex justify-end items-center pt-3 mt-3 border-t border-slate-200/50">
                    <span className={`text-[11px] font-black flex items-center gap-1 ${item.color} group-hover:translate-x-1 transition-transform`}>
                      Abrir módulo <span className="text-sm leading-none">›</span>
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* VISTA 2: HERRAMIENTA ACTIVA */}
        {herramientaActiva && (
          <div className={`transition-all duration-200 ${animating ? "opacity-0 translate-y-2" : "opacity-100 translate-y-0"}`}>
            <div className="bg-white/80 backdrop-blur-xl border border-white rounded-2xl p-4 sm:p-6 shadow-inner">
              <div className="flex items-center justify-between pb-4 mb-5 border-b border-slate-200/70">
                <div className="flex items-center gap-3">
                  <span className={`w-9 h-9 rounded-xl flex items-center justify-center text-lg border ${herramientas.find(h => h.id === herramientaActiva)?.bgIcon}`}>
                    {herramientas.find(h => h.id === herramientaActiva)?.icon}
                  </span>
                  <h2 className="text-base sm:text-lg font-black text-slate-800 tracking-tight">
                    {herramientas.find(h => h.id === herramientaActiva)?.title}
                  </h2>
                </div>
                <button
                  type="button"
                  onClick={handleCloseTool}
                  className="w-auto flex-none px-3 py-1.5 bg-rose-50 hover:bg-rose-100 text-rose-600 rounded-lg font-black text-[10px] uppercase tracking-wider transition cursor-pointer"
                >
                   Cerrar
                </button>
              </div>

              <div className="w-full">
                {herramientaActiva === "notificaciones" && <NotificacionesMasivas />}
                {herramientaActiva === "perfiles" && <GestionPerfiles />}
                {herramientaActiva === "menus" && <GestionMenus />}
                {herramientaActiva === "sedes" && <GestionSedes />}
                {herramientaActiva === "sysplus" && <SincronizadorSysplus />}
              </div>
            </div>
          </div>
        )}

      </div>
    </div>
  );
}